import { useState } from "react";
import styled from "styled-components";
import SumsubWebSdk from "@sumsub/websdk-react";
import { Button, Modal, Spinner } from "../../../../../../components";
import { useKYC } from "../../../../../../pages/userPanel/KYC/useKYC";
import { useAppDispatch, useAppSelector } from "../../../../../../redux";
import { closeMissingKycModal } from "../../../../../../redux/features/uiSlice";
import { TokenType } from "../../../../../../constants";

const ModalBodyWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 24px;
  justify-content: flex-start;
  align-items: center;
`;

export const MissingKyc = () => {
  const { isOpenMissingKycModal } = useAppSelector((state) => state.ui);
  const [isOpenKycVerification, setIsKycVerificationOpen] = useState(false);

  const dispatch = useAppDispatch();

  const handleCloseAndResetState = () => {
    setIsKycVerificationOpen(false);
    dispatch(closeMissingKycModal());
  };

  const {
    accessToken,
    fetchAccessToken,
    config,
    options,
    accessTokenExpirationHandler,
    errorHandler,
  } = useKYC({
    handleModalClose: handleCloseAndResetState,
  });

  const handleOpenKycVerification = () => {
    setIsKycVerificationOpen(true);
    fetchAccessToken(TokenType.INDIVIDUAL);
  };

  return (
    <Modal
      isOpen={isOpenMissingKycModal}
      title={accessToken ? ["KYC", "Verification"] : ["Missing", "KYC data"]}
      description={
        !accessToken
          ? [
              "Unfortunately, your data is incomplete.",
              "During the KYC procedure, we received incomplete information about you. All you need to do now is:",
              " Click the button below to approve your KYC data again.",
            ]
          : [""]
      }
      onClose={handleCloseAndResetState}
      withOutsideClick
    >
      <ModalBodyWrapper>
        {isOpenKycVerification ? (
          !accessToken ? (
            <div
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                minHeight: "80%",
                minWidth: "100vw",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#FFF",
                zIndex: 99999,
              }}
            >
              <Spinner />
            </div>
          ) : (
            <div
              style={{
                position: "absolute",
                right: 0,
                top: 0,
                height: "100%",
                width: "100%",
                overflow: "hidden",
                zIndex: 1001,
              }}
            >
              <SumsubWebSdk
                accessToken={accessToken}
                expirationHandler={accessTokenExpirationHandler}
                config={config}
                options={options}
                onError={errorHandler}
              />
            </div>
          )
        ) : (
          <Button.Primary onClick={handleOpenKycVerification}>
            Approve your KYC data
          </Button.Primary>
        )}
      </ModalBodyWrapper>
    </Modal>
  );
};
